import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/about/page.tsx")